var React = require('react');

function SomeLinkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24.7103 24.6155H20.8749V18.154C20.8749 17.1406 19.7359 16.2929 18.7209 16.2929C17.7059 16.2929 17.0396 17.1406 17.0396 18.154V24.6155H13.2042V13.1284H17.0396V15.0429C17.6746 14.0172 19.299 13.3555 20.4195 13.3555C22.7892 13.3555 24.7103 15.3096 24.7103 17.6754V24.6155ZM11.2865 24.6155H7.45117V13.1284H11.2865V24.6155ZM9.36886 7.38477C10.428 7.38477 11.2865 8.24193 11.2865 9.2993C11.2865 10.3567 10.428 11.2138 9.36886 11.2138C8.30975 11.2138 7.45118 10.3567 7.45118 9.2993C7.45118 8.24193 8.30975 7.38477 9.36886 7.38477Z","fill":"white"}));
}

SomeLinkedin.defaultProps = {"width":"33","height":"32","viewBox":"0 0 33 32","fill":"none"};

module.exports = SomeLinkedin;

SomeLinkedin.default = SomeLinkedin;
